import { render, staticRenderFns } from "./CustomerListSideMenu.vue?vue&type=template&id=57480438&scoped=true"
import script from "./CustomerListSideMenu.vue?vue&type=script&lang=js"
export * from "./CustomerListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57480438",
  null
  
)

export default component.exports